export default __webpack_public_path__ + "static/media/903.e4477c51.jpg";